import { defineStore } from "pinia";
import { ILiveStats } from "@/features/live-stats/live-stats.types";
import { ref } from "vue";

export const useLiveStatsStore = defineStore("live-stats", () => {
  const liveStatsData = ref<ILiveStats>();

  return {
    liveStatsData,
  };
});
